var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneRus = function SvgPhoneRus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "phone-rus_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#phone-rus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#phone-rus_svg__b)",
    d: "M-3 0h22v16H-3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "phone-rus_svg__b",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#phone-rus_svg__c",
    transform: "matrix(.00397 0 0 .00546 -.046 0)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAIAAAC+MS2jAAACKUlEQVR4nO3XwQkCQRBFwV1ZPQhG4ME4zMlMDUgQdI3BdxkGqiL4lwfd677vC/Cnw+gBMCXlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDxbosj9EbYD7b6XoZvQHm41qDQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQbO/PcfQGmM/6vN9Gb4D5bK/vefQGmI8/BwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKH7AQwonjIcwVQAAAABJRU5ErkJggg==",
    id: "phone-rus_svg__c",
    width: 275,
    height: 183
  }))));
};
export { SvgPhoneRus as ReactComponent };